import { BREAKPOINTS, TextButton as Button, COLORS, HorizontalCard } from '@laerdal/life-react-components';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMarketPath } from '../store/slices/globalConfigSlice';

const Contact = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  border-radius: 8px;
  background: ${COLORS.neutral_20};
`;


const HorizontalCardFullWidth = styled(HorizontalCard)`
  div {
    padding:24px;
  }
  div > div {
    padding: unset;
    flex-direction: column;
  }
  width: 100%;
  div > div:nth-child(2) {
    margin: 0 20px 0 0 ;
  }
  
  div {
    flex-direction: column;
    align-items: start;
    gap: 8px;
  }
  ${BREAKPOINTS.MEDIUM} {
    div {
      align-items: start;
      flex-direction: row;
      gap: 8px;
    }
  }
`

const ContactSupport = () => {
  const { t } = useTranslation('translation');

  const currentMartketPath = useSelector(selectMarketPath);
  const navigate = useNavigate()

  return (
    <HorizontalCardFullWidth
      variant="outline"
      title={t('Get Support')}
      description={t('Explore our support options to find the help you need. Click here to get started and connect with our expert team.')}
      action={() => {
        posthog?.capture('SUPP-GetSupport', {
          url: window.location.href,
          ref: document.referrer
        });

        navigate(`${currentMartketPath}/case/create`);
      }}
      actions={[{
        componentType: 'custom',
        content: <Button variant='secondary' onClick={() => {
          posthog?.capture('SUPP-GetSupport', {
            url: window.location.href,
            ref: document.referrer
          });

          navigate(`${currentMartketPath}/case/create`);
        }} >{t('Contact Support')}</Button>
      }
      ]} />
  );
}

export default ContactSupport;

